import React, { Component } from 'react';
import Page from '../../containers/page';

import {
    Container,
    Row,
    Col,
    Button,
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import FormBuilder from '../../components/forms/modalFormBuilder';
import { required } from '../../components/forms/validation';

import ListBuilder from '../../components/listBuilder';
import DeleteModal from '../../components/deleteModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import { API_ENDPOINT, DOMAINS } from '../../constants';

import edit from '../../assets/svg/edit.svg'
import garabage from '../../assets/svg/garbage.svg'
import Search from '../../components/search';
import addIcon from '../../assets/svg/add-icon.svg';

import profileUser from '../../assets/images/user.png';
import notification from '../../assets/svg/notification.svg'
import moreIcon from '../../assets/svg/more.svg'

import { Player, Controls } from '@lottiefiles/react-lottie-player';
import ErrorModal from '../../components/errorModal_v2';
import InfoModal from '../../components/infoModal';


/**
* Translations page
* @author   Milan Stanojevic
*/
class Translation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            items: [],
            total: 0,
            loading: true
        };
    }


    get = () => {
        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));

        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })).then((data) => {
                let dataToSet = { ...data }
                if (dataToSet.page || dataToSet.items || dataToSet.total) {
                    dataToSet.loading = null;
                    // console.log(dataToSet.page || dataToSet.items || dataToSet.total)
                    let checkFilter = '';
                    if (dataToSet.resultFilter) {
                        checkFilter = String(dataToSet.resultFilter)
                        delete dataToSet.resultFilter;
                    }
                    let search = this.props[0].location.search;
                    let serachParams = getSearchParams(search);
                    let searchParamsFilter = '';
                    if (serachParams.filter) {
                        searchParamsFilter = serachParams.filter;
                    }
                    if (searchParamsFilter != checkFilter) {
                        delete dataToSet.page;
                        delete dataToSet.items;
                        delete dataToSet.total;
                        delete dataToSet.loading;
                    }
                }
                this.setState({
                    ...dataToSet,
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();

        const internationalDomains = this.checkDomains();
        this.setState({ internationalDomains })
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }
    }


    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, [{ name: 'sortField', value: field }, { name: 'sortType', value: type }], false));

        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0 }, name, value, restart));
        }
    }
    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, fields, restart));
        }
    }


    /**
    * Insert or update translation
    * @author   Milan Stanojevic
    * @Objectparam    {String} key                 key of translation
    * @Objectparam    {String} en                  english translation
    * @Objectparam    {String} se                  swedish translation
    */
    insertOrUpdate = (data) => {
        this.setState({
            loading: true,
            _saving: true
        }, () => {
            if (!this.state.form._id) {

                fetch(API_ENDPOINT + '/languages/translation/new', {
                    method: 'PUT',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then(res => res.json()).then((result) => {
                    this.get();
                    this.setState({
                        _saving: false
                    }, () => {
                        setTimeout(() => {
                            this.setState({ _saving: false, form: null })
                        }, 1000)
                    })
                })
            } else {
                fetch(API_ENDPOINT + '/languages/translation/' + this.state.form._id, {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then(res => res.json()).then((result) => {
                    this.get();
                    this.setState({
                        _saving: false
                    }, () => {
                        setTimeout(() => {
                            this.setState({ _saving: false, form: null })
                        }, 1000)
                    })
                })
            }
        })
    }

    stopAnimation = () => {
        this.player.current.play();
    }

    /**
    * Delete translation
    * @author   Milan Stanojevic
    * @Objectparam    {String} id                  translation's id
    */
    delete = (id) => {
        this.setState({
            loading: true
        }, () => {

            fetch(API_ENDPOINT + '/languages/translation/' + id, {
                method: 'DELETE',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
            }).then(res => res.json()).then((result) => {
                this.get();
            })
        })

    }

    updateLanguageSettings = () => {
        let action = this.props.secondaryLanguageDisabled ? 'enable' : 'disable';
        this.setState({ loading: true }, async () => {
            const response = await fetch(API_ENDPOINT + '/system/language', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${localStorage?.getItem?.('authToken')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ action })
            });
            if (response) {
                const result = await response.json();
                if (result) {
                    if (result.error) this.setState({ error: result.error })
                }
            };

            this.setState({ loading: false }, () => {
                this.props.getPlatformInfo?.();
            })
        })
    }
    insertInternationals = (data) => {
        if (!data?.key || !data.en) return;
        let obj = {
            key: data.key,
            en: data.en,
            translationData: {}
        };
        const internationalDomains = this.state.internationalDomains || [];
        for (let i = 0; i < internationalDomains.length; i++) {
            const key = internationalDomains[i].slug;
            if (data[key]) {
                obj.translationData[key] = {
                    value: data[key],
                    name: internationalDomains[i].name,
                    api: internationalDomains[i].api
                }
            } else {
                obj.translationData[key] = {
                    value: data.en,
                    name: internationalDomains[i].name,
                    api: internationalDomains[i].api
                }
            }
        }


        this.setState({
            loading: true,
            _saving: true
        }, () => {
            fetch(API_ENDPOINT + '/languages/internationals-translation/new', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(obj)
            }).then(res => res.json()).then((result) => {
                let responseArr = [];
                let anyError = false;
                if (result) {
                    for (var key in result) {
                        if (result[key].error) {
                            anyError = true;
                        }
                        responseArr.push({
                            key: key,
                            ...result[key]
                        })
                    }
                }
                this.get();
                this.setState({
                    _saving: false,
                    loading: null,
                    infoInsert: responseArr.length > 0 ? responseArr : null,
                }, () => {
                    if (!anyError) {
                        setTimeout(() => {
                            this.setState({ _saving: false, formInternationals: null }, () => {
                                this.setState({ formInternationals: {} })
                            })
                        }, 1000)
                    }
                })
            })

        })

    }
    generateSlug = (name) => {
        if (!name) return '';
        return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').replace(/-/, '_');
    }
    checkDomains = () => {
        let response = [];
        if (DOMAINS?.length) {
            for (let i = 0; i < DOMAINS.length; i++) {
                const domain = DOMAINS[i];
                if (!domain?.domen) continue;
                let condition = false;
                if (domain.domen?.indexOf('https://test.') > -1) condition = true;
                if (domain.domen?.indexOf('https://dev.curoflow.se') > -1) condition = true;
                if (domain.domen?.indexOf('https://test.curoflow.se') > -1) condition = false;

                if (!condition) continue;

                response.push({
                    ...domain,
                    slug: this.generateSlug(domain?.name),
                })

            }
        }
        response.sort((a, b) => {
            const order = ['se', 'es', 'gr', 'dk', 'ch', 'ro', 'uk', 'ae'];
            const aIndex = order.indexOf(a.slug.split('_')[0]);
            const bIndex = order.indexOf(b.slug.split('_')[0]);
            return aIndex - bIndex;
        });


        return response;
    }

    render() {
        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })
        }
        const defaultOptions = {
            loop: true,
            autoplay: true,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        const showAddInternationals = typeof window !== 'undefined' && window.origin &&
            (/*window.origin?.indexOf('localhost') > -1 ||*/ window.origin?.indexOf('dev.curoflow.se') > -1) ?
            true
            :
            false;

        const internationalDomains = this.state.internationalDomains || [];
        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>

                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <div className="panel">
                                <div className="panel-header" style={{ flexWrap: 'wrap' }}>
                                    <h5 className="component-header">{this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}</h5>
                                    <div>
                                        {
                                            showAddInternationals && internationalDomains?.length ?
                                                <button className="btn add-button" style={{ marginRight: 10 }} onClick={() => this.setState({
                                                    formInternationals: {}
                                                })}><Isvg src={addIcon} /> {'Add - internationals'.translate(this.props.lang)}</button>
                                                :
                                                null
                                        }

                                        <button className="btn add-button" onClick={() => this.setState({
                                            form: {}
                                        })}><Isvg src={addIcon} /> {'Add'.translate(this.props.lang)}</button>
                                        <Button onClick={this.updateLanguageSettings} style={{ marginLeft: 10, height: 48, paddingRight: 20, paddingLeft: 20 }} size='lg' color={this.props.secondaryLanguageDisabled ? 'primary' : 'danger'}>
                                            {this.props.secondaryLanguageDisabled ? 'Enable Secondary Language'.translate(this.props.lang) : 'Disable Secondary Language'.translate(this.props.lang)}
                                        </Button>
                                    </div>
                                </div>
                                <ListBuilder
                                    lang={this.props.lang}
                                    loading={this.state.loading}
                                    total={this.state.total}
                                    showNumeration={false}
                                    fields={[
                                        { type: 'text', name: 'key', label: 'Key'.translate(this.props.lang), allowSort: true },
                                        { type: 'text', name: 'en', label: 'English'.translate(this.props.lang), allowSort: true },
                                        { type: 'text', name: 'se', label: 'Swedish'.translate(this.props.lang), allowSort: true },
                                    ]}
                                    items={this.state.items}
                                    actions={
                                        [
                                            {
                                                component: <Isvg src={edit} className="edit-icon" />,
                                                onClick: (item) => this.setState({ form: item })
                                            },
                                            {
                                                component: <Isvg src={garabage} className="delete-icon" />,
                                                onClick: (item) => this.setState({ deleteModal: item })
                                            },
                                        ]
                                    }
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                ></ListBuilder>
                                <DeleteModal
                                    lang={this.props.lang}
                                    isOpen={this.state.deleteModal}
                                    toggle={() => this.setState({ deleteModal: null })}
                                    handler={() => { this.delete(this.state.deleteModal._id); this.setState({ deleteModal: null }) }}
                                >
                                    {'Delete translation'.translate(this.props.lang)} <strong>{this.state.deleteModal && this.state.deleteModal.name}</strong>?
                                </DeleteModal>

                            </div>
                        </Col>
                    </Row>

                </Container>
                {
                    this.state.infoInsert ?
                        <InfoModal
                            isOpen={this.state.infoInsert}
                            toggle={() => this.setState({ infoInsert: null })}
                            header={'Info'.translate(this.props.lang)}
                            info={<div>
                                {this.state.infoInsert.map((item, idx) => {
                                    return (
                                        <div key={idx} style={{ marginBottom: 10, color: item.error ? 'red' : 'green', fontSize: 14 }}>
                                            <strong style={{ fontWeight: 600 }}>{item.key}</strong> - {item.message}
                                        </div>
                                    )
                                })}
                            </div>}
                            buttons={[
                                <Button color='primary' onClick={() => {
                                    this.setState({
                                        infoInsert: null,
                                    })


                                }}>{'Ok'.translate(this.props.lang)}</Button>
                            ]}

                        />
                        :
                        null
                }
                {
                    this.state.formInternationals ?
                        <FormBuilder selectedGroup={this.props.selectedGroup} selectedClinic={this.props.selectedClinic} countryTwoLetter={this.props.countryTwoLetter} country={this.props.country} dateFormat={this.props.dateFormat}
                            lang={this.props.lang}
                            getStringDateTs={this.props.getStringDateTs}
                            onSubmit={(data) => this.insertInternationals(data)}
                            initialValues={this.state.formInternationals}
                            isOpen={this.state.formInternationals}
                            toggle={() => this.setState({ formInternationals: null })}
                            title={'Add new translation'.translate(this.props.lang)}
                            _saving={this.state._saving}
                            buttonConfirmText={'Saved'.translate(this.props.lang)}
                            buttonText={'Save'.translate(this.props.lang)}

                            fields={[
                                {
                                    type: 'row',
                                    children: [
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 12,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'text',
                                                    name: 'key',
                                                    disabled: false,
                                                    label: 'Key'.translate(this.props.lang),
                                                    validate: [required("Key is required!".translate(this.props.lang))],
                                                },
                                            ]
                                        },
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 12,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'text',
                                                    name: 'en',
                                                    label: 'English'.translate(this.props.lang),
                                                    validate: [required("English is required!".translate(this.props.lang))],
                                                },
                                            ]
                                        },

                                        ...internationalDomains?.map((item, idx) => {
                                            return {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: item?.slug,
                                                        label: item?.name
                                                    },
                                                ]
                                            }
                                        })

                                    ]
                                }
                            ]}
                        ></FormBuilder>
                        :
                        null
                }
                {
                    this.state.form ?
                        <FormBuilder selectedGroup={this.props.selectedGroup} selectedClinic={this.props.selectedClinic} countryTwoLetter={this.props.countryTwoLetter} country={this.props.country} dateFormat={this.props.dateFormat}
                            lang={this.props.lang}
                            getStringDateTs={this.props.getStringDateTs}
                            onSubmit={(data) => this.insertOrUpdate(data)}
                            initialValues={this.state.form}
                            isOpen={this.state.form}
                            toggle={() => this.setState({ form: null })}
                            title={this.state.form._id ? 'Edit translation'.translate(this.props.lang) : 'Add new translation'.translate(this.props.lang)}
                            _saving={this.state._saving}
                            buttonConfirmText={'Saved'.translate(this.props.lang)}
                            buttonText={'Save'.translate(this.props.lang)}

                            fields={[
                                {
                                    type: 'row',
                                    children: [
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 12,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'text',
                                                    name: 'key',
                                                    disabled: false,
                                                    label: 'Key'.translate(this.props.lang),
                                                },
                                            ]
                                        },
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 12,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'text',
                                                    name: 'en',
                                                    label: 'English'.translate(this.props.lang),
                                                },
                                            ]
                                        },
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 12,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'text',
                                                    name: 'se',
                                                    label: 'Swedish'.translate(this.props.lang),
                                                },
                                            ]
                                        },

                                    ]
                                }
                            ]}
                        ></FormBuilder>
                        :
                        null
                }
                {
                    this.state.error ? <ErrorModal buttons={[{ onClick: this.setState({ error: null }), text: 'OK'.translate(this.props.lang) }]}>
                        <p>{this.state.error?.translate(this.props.lang)}</p>
                    </ErrorModal> : null
                }

            </div >
        );
    }
}

export default Page(Translation);